// Columns shared by both the season and fixture roster tables.
export enum RosterTableColumns {
  PersonId = "personId",
  NameFullLocal = "nameFullLocal",
  PersonExternalId = "person.externalId",
  PersonNameFullLatin = "person.nameFullLatin",
  PersonAdditionalDetailsHeight = "person.additionalDetails.height",
  PersonAdditionalDetailsWeight = "person.additionalDetails.weight",
  PersonAdditionalDetailsHeightImperial = "person.additionalDetails.heightImperial",
  PersonAdditionalDetailsWeightImperial = "person.additionalDetails.weightImperial",
  PersonAdditionalDetailsRepresentation = "person.additionalDetails.representation",
  PersonAdditionalDetailsJuniorAssociationLeague = "person.additionalDetails.juniorAssociationLeague",
  PersonAdditionalDetailsHomeTown = "person.additionalDetails.homeTown",
  PersonAdditionalDetailsCollege = "person.additionalDetails.college",
  PersonAdditionalDetailsCollegeClass = "person.additionalDetails.collegeClass",
  PersonAdditionalDetailsSchool = "person.additionalDetails.school",
  PersonAdditionalDetailsSchoolClass = "person.additionalDetails.schoolClass",
  Dob = "dob",
  PersonGender = "person.gender",
  PersonNationality = "person.nationality",
  PersonRepresenting = "person.representing",
  PersonStatus = "person.status",
  Bib = "bib",
  ExternalId = "externalId",
  Position = "position",
  IsCaptain = "isCaptain",
  Caps = "caps",
}
